import { createContext, useContext, useMemo } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookie] = useCookies();

  const login = async ({ email, password }) => {
    try {
      const res = await api.post("/auth/login", {
        email: email,
        password: password,
      });

      setCookies("data", res.data);
      // setCookies("first_name", res.data.first_name);
      // setCookies("last_name", res.data.last_name);
      // setCookies("matric_no", res.data.matric_no);
      // setCookies("gender", res.data.gender);
      // setCookies("course_of_study", res.data.course_of_study);
      // setCookies("hall", res.data.hall);
      // setCookies("level", res.data.level);
      // setCookies("phone_no", res.data.phone_no);
      // setCookies("role", res.data.user);

      if (res.data.role === 0) {
        navigate("/admin");
      } else if (res.data.role === 1) {
        navigate("/meal-setup");
      } else if (res.data.role === 2) {
        navigate("/home");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const signup = async ({
    email,
    password,
    role,
    first_name,
    last_name,
    matric_no,
    level,
    gender,
    course_of_study,
    hall,
    meal_option,
    phone_no,
    semester,
  }) => {
    try {
      const res = await api.post(
        "/auth/signup",
        {
          email: email,
          role: role,
          password: password,
          first_name: first_name,
          last_name: last_name,
          matric_no: matric_no,
          gender: gender,
          course_of_study: course_of_study,
          hall: hall,
          meal_option: meal_option,
          level: level,
          phone_no: phone_no,
          semester: semester,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      // setCookies("token", res.data.token); // your token
      // setCookies("first_name", res.data.first_name);
      // setCookies("last_name", res.data.last_name);
      // setCookies("matric_no", res.data.matric_no);
      // setCookies("gender", res.data.gender);
      // setCookies("course_of_study", res.data.course_of_study);
      // setCookies("hall", res.data.hall);
      // setCookies("level", res.data.level);
      // setCookies("phone_no", res.data.phone_no);
      // setCookies("meal_option", res.data.meal_option);
      // setCookies("semester", res.data.semester);

      if (res.data.msg === "success") {
        navigate("/login");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const setupmeal = async (details) => {
    // try {
    // const res = await api.post(
    //   "/transactions/meal-setup",
    //   { fullname, foodname, mealtype},
    //   {
    //     headers: {
    //       Authorization: `Bearer ${cookies.token}`,
    //   }
    // });

    if (details.fullname !== "" || details.foodname !== "" || details.mealtype !== "") {
      // const details = { fullname, foodname, mealtype };
      console.log(details);
      setCookies("attendant", details);
      navigate("/scanned-transactions");
    } else {
      console.log("Set up meal");
      navigate("/meal-setup")
    }
    // } catch(err) {
    // console.log(err)
    // }
  };

  const logout = () => {
    ["data", "attendant"].forEach((obj) => removeCookie(obj)); // remove data save in cookies
    console.log(cookies);
    navigate("/login");
  };

  const value = useMemo(
    () => ({
      cookies,
      login,
      logout,
      signup,
      setupmeal,
    }),
    [cookies]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useAuth = () => {
  return useContext(UserContext);
};
